<app-modal
  *ngIf="mainContent && secondaryAction && primaryAction"
  [modalTitle]="'projectDetails.investInfoDialog.title' | translate"
  [mainContentTemplate]="mainContent"
  [secondaryActionTemplate]="secondaryAction"
  [primaryActionTemplate]="primaryAction"
  (closed)="activeModal.dismiss()"
  class="invest-modal"
></app-modal>

<ng-template #mainContent>
  <div class="stepper-container">
    <div class="step-item">
      <div class="step-circle">1</div>
      <div class="step-content">
        {{ "projectDetails.investInfoDialog.step1" | translate }}
      </div>
    </div>

    <div class="step-item">
      <div class="step-circle">2</div>
      <div class="step-content">
        {{ "projectDetails.investInfoDialog.step2" | translate }}
      </div>
    </div>

    <div class="step-item">
      <div class="step-circle">3</div>
      <div class="step-content">
        {{ "projectDetails.investInfoDialog.step3" | translate }}
      </div>
    </div>

    <div class="step-item">
      <div class="step-circle">4</div>
      <div class="step-content">
        {{ "projectDetails.investInfoDialog.step4" | translate }}
      </div>
    </div>
  </div>

  <!--div class="mt-4 mb-3">
    <p class="text-secondary small">
      {{ "projectDetails.investInfoDialog.moreInfo" | translate }}
      <a href="#" class="text-primary fw-bold">{{
        "projectDetails.investInfoDialog.faq" | translate
      }}</a>
      {{ "projectDetails.investInfoDialog.findOnPage" | translate }}
    </p>
  </div-->

  <hr class="modal-divider" />

  <form [formGroup]="investForm">
    <div class="mb-2">
      <app-validated-checkbox
        label="projectDetails.investInfoDialog.dontShowAgain"
        inputFormControlName="dontShowAgain"
        [inputFormControl]="investForm.controls.dontShowAgain"
      ></app-validated-checkbox>
    </div>
  </form>
</ng-template>

<ng-template #secondaryAction>
  <button
    class="btn btn-outline-secondary px-4"
    type="button"
    (click)="activeModal.dismiss()"
  >
    {{ "general.cancel" | translate }}
  </button>
</ng-template>

<ng-template #primaryAction>
  <button class="btn btn-primary px-4" type="submit" (click)="continue()">
    {{ "general.continue" | translate }}
    <span class="fas fa-chevron-right ms-2"></span>
  </button>
</ng-template>
